/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EmployeeListing = {
    properties: {
        employees: {
    type: 'array',
    contains: {
        type: 'ListedEmployee',
    },
    isRequired: true,
},
    },
};